import React from 'react';
import { useCellData } from '../../../../SiteContext/useCell';
import Box from '../../../../styled/Box';
import LinkButton from '../../../../styled/LinkButton';
import { Column, Columns } from '../../../../styled/Columns/wrappers';
import Distance from '../../../../styled/Distance';
import Text from '../../../../styled/Text';
import { Headline, Heading } from '../../../../styled/Headline/wrappers';
import { WalletIcon } from '../../../../styled/Icon';
import Link from '../../../../Router/Link';
import useToggle from '../../../../hooks/useToggle';
import Panel from '../../../../styled/Panel';
import HtmlContent from '../../../../components-legacy/HtmlContent';
import { usePrice } from '../providers/PriceProvider';
import { useTrackGenericEvent } from '../../../../hooks/tracking/useTrackingEvents';
import useCompose from '../../../../hooks/useCompose';
import CreditWarning from '../../../../components/CreditWarning';

const readMoreClickEvent = { event: 'part_payment_readmore_click' };
const seeCreditClickEvent = { event: 'part_payment_credit_info_click' };

interface IPartPayment {
  partPayment?: {
    buttonText: string;
    description: string;
    minValue: number;
    linkLabel: string;
  };
}

const PartPayment = () => {
  const { price } = usePrice();
  const { partPayment } = useCellData<IPartPayment>();
  const [showInfo, toggleShowInfo] = useToggle(false);
  const trackReadMoreClick = useTrackGenericEvent(readMoreClickEvent);
  const trackCreditClick = useTrackGenericEvent(seeCreditClickEvent);

  const readMoreClickHandler = useCompose(trackReadMoreClick, toggleShowInfo);

  if (!partPayment || !price || price < partPayment?.minValue) {
    return null;
  }

  return (
    <>
      <Distance size="3" />
      <Box background="highlight" overhang="mobile" rounded>
        <Columns className="space-2">
          <Column>
            <WalletIcon className="xlarge bump-down" />
          </Column>
          <Column>
            <Headline>
              <Heading>Betala med Resurs</Heading>
            </Headline>
            <Distance size="half" />
            <Columns className="space-1">
              <Column>
                <LinkButton weight="regular" onClick={readMoreClickHandler}>
                  {partPayment.linkLabel}
                </LinkButton>
              </Column>
              <Column>
                <Text tone="alt">|</Text>
              </Column>
              <Column>
                <Link
                  as="a"
                  Component={LinkButton}
                  href="https://www.mio-wallet.resursbank.se/login"
                  onBeforeNavigate={trackCreditClick}
                  rel="noopener nofollow"
                  target="_blank"
                  weight="regular">
                  Se ditt köputrymme
                </Link>
              </Column>
            </Columns>
          </Column>
        </Columns>
      </Box>
      {showInfo && (
        <Panel onClose={toggleShowInfo}>
          <HtmlContent html={partPayment.description} />
          <hr />
          <CreditWarning boxed={false} />
        </Panel>
      )}
    </>
  );
};

export default PartPayment;
